/* eslint-disable react/jsx-filename-extension */
import PropTypes from 'prop-types';
import {
  AddCircleOutline as AddCircleOutlineIcon,
  Label as LabelIcon,
  Search as SearchIcon,
  TextFields as TextFieldsIcon,
} from '@material-ui/icons';

export const DEFAULT_PROPS = {
  disabled: false,
  onChange: () => {},
  settings: {},
};

export const PROP_TYPES = {
  disabled: PropTypes.bool,
  error: PropTypes.string,
  events: PropTypes.shape({
    onChange: PropTypes.func,
  }),
  label: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.oneOf(['medium', 'small']),
  settings: PropTypes.shape({
    accept: PropTypes.array,
    base64: PropTypes.bool,
    multiple: PropTypes.bool,
  }),
  onChange: PropTypes.func,
  defaultFile: PropTypes.any,
  defaultFileName: PropTypes.string,
  defaultSignatures: PropTypes.object,
  defaultFunctions: PropTypes.object,
  readOnly: PropTypes.bool,
};

export const TYPE_MAP = {
  1: 'default',
  2: 'client',
  3: 'relations',
};

export const HEADERS = [
  {
    hidden: process.env.NODE_ENV === 'production',
    name: 'id',
  },
  {
    name: 'name',
  },
  {
    name: 'email',
  },
  {
    name: 'telefono',
  },
  {
    name: 'description',
  },
  {
    name: 'type',
  },
  {
    name: 'cantidad',
  },
];

// Factories i18n-dependientes: reciben `t` y devuelven el dato traducido.
// Mantienen la misma identidad de creación que el código original (nuevo array por llamada).

export const getSignersButtonGroup = (t) => [
  {
    label: t('actions.list'),
    value: 'list',
  },
  {
    label: t('actions.create_signer'),
    value: 'add',
  },
];

export const getSelectorTypes = (t) => [
  {
    id: 1,
    name: t('forms.selectors.default'), // mandar siempre el id 0
  },
  {
    id: 2,
    name: t('forms.selectors.client'), // obtener de plantillas de personas
  },
  {
    id: 3,
    name: t('forms.selectors.relationships'), // obtener de selector de relaciones de clientes
  },
];

export const getStepsQuestion1 = (t) => [
  t('messages.steep_one'),
  t('messages.steep_two'),
  t('messages.steep_three'),
  t('messages.steep_four'),
];

export const getStepsQuestion2 = (t) => [
  {
    label: t('messages.step_tool_access'),
    icon: <LabelIcon />,
  },
  {
    label: t('messages.step_find_add_button'),
    icon: <SearchIcon />,
  },
  {
    label: t('messages.step_enter_label_name'),
    icon: <TextFieldsIcon />,
  },
  {
    label: t('messages.step_press_enter_add'),
    icon: <AddCircleOutlineIcon />,
  },
];

// Helpers puros

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export function cleanString(str) {
  return str
    .replace(/{{\s*([\w\s.]+)\s*}}/g, '$1')
    .replace(/^[\w]+\./, '')
    .replace(/\s+/g, ' ');
}

export function cleanTemplate(str) {
  if (!str) return '';
  return str.replace(/{{\s*([^|}]+).*?}}/, '{{$1}}');
}

export function updateValuesFromMapeo(values) {
  return values.map((obj) => {
    if (obj.mapeo && Object.keys(obj.mapeo).length > 0) {
      obj.name =
        obj.name.trim() === ''
          ? obj.mapeo.displayNameName || obj.name
          : obj.name;
      obj.telefono =
        obj.telefono.trim() === ''
          ? obj.mapeo.displayNameTelefono || obj.telefono
          : obj.telefono;
      obj.email =
        obj.email.trim() === ''
          ? obj.mapeo.displayNameEmail || obj.email
          : obj.email;
    }
    return obj;
  });
}

export const replaceKeyInArray = function (array, oldKey, newKey) {
  return array.map((obj) => {
    if (obj.hasOwnProperty(oldKey)) {
      obj[newKey] = obj[oldKey];
      delete obj[oldKey];
    }
    return obj;
  });
};

export function filterValidClients(array) {
  if (!Array.isArray(array)) {
    return [];
  }

  return array.filter(
    (item) =>
      item &&
      typeof item === 'object' &&
      item.hasOwnProperty('id') &&
      item.hasOwnProperty('name') &&
      item.id !== undefined &&
      item.id !== null,
  );
}
